import { z } from 'zod'
import { ApiError } from '@/util/errors/api-error'

/** Stable refusal codes from /api/v1/identity-bridge/link-codes/{preview,consume}. */
export enum OutlookLinkRefusalCode {
  CodeInvalid = 'link_code_invalid',
  AccountNotEligible = 'account_not_eligible',
  IdentityAlreadyLinked = 'identity_already_linked',
  AccountAlreadyLinked = 'account_already_linked',
}

/** An expected refusal the page explains to the user. Not reported as a fault. */
export class OutlookLinkRefusedError extends ApiError {
  readonly code: OutlookLinkRefusalCode

  constructor(status: number, code: OutlookLinkRefusalCode) {
    super(status, `Outlook link refused: ${code}`)
    this.name = 'OutlookLinkRefusedError'
    this.code = code
  }
}

const RefusalSchema = z.object({ detail: z.object({ code: z.nativeEnum(OutlookLinkRefusalCode) }) })

/** Only the API's coded body counts; a proxy or framework error with the same status does not. */
export function parseOutlookLinkRefusal(status: number, body: unknown): OutlookLinkRefusedError | null {
  const parsed = RefusalSchema.safeParse(body)
  return parsed.success ? new OutlookLinkRefusedError(status, parsed.data.detail.code) : null
}
